$(function () {
  var rellax = new Rellax(".rellax", {
    speed: -1,
    center: true,
    wrapper: null,
    vertical: true,
    horizontal: false,
  });
  $(".product-flavor-list li").on("click", function () {
    $(".product-flavor-list li").removeClass("active");
    $(this).addClass("active");
  });
  $(".component-flavor-list li").on("click", function () {
    $(".component-list").fadeOut();
    $(".component-flavor-list li,.component-list").removeClass("active");
    $(this).addClass("active");
    var index = $(".component-flavor-list li").index(this);
    $(".component-list").eq(index).fadeIn();
    $(".component-list").eq(index).addClass("active");
  });

  // NOBITA商品フォーム連携機能
  class NobitaProductFormConnector {
    constructor() {
      this.currentQuantity = 1;
      this.currentVariantId = null;
      this.init();
    }

    init() {
      this.bindEvents();
      this.syncInitialState();
    }

    bindEvents() {
      // フレーバー選択の連携
      $("[data-nobita-variant-selector] li").on("click", (e) => {
        const $target = $(e.currentTarget);
        const variantId = $target.data("variant-id");
        const variantTitle = $target.data("variant-title");

        if (variantId) {
          this.currentVariantId = variantId;
          this.updateInvisibleFormVariant(variantId, variantTitle);
        }
      });

      // 数量調整の連携
      $("[data-nobita-quantity-decrease]").on("click", () => {
        if (this.currentQuantity > 1) {
          this.currentQuantity--;
          this.updateQuantityDisplay();
          this.updateInvisibleFormQuantity();
        }
      });

      $("[data-nobita-quantity-increase]").on("click", () => {
        this.currentQuantity++;
        this.updateQuantityDisplay();
        this.updateInvisibleFormQuantity();
      });

      // カートに追加ボタンの連携
      $("[data-nobita-add-to-cart]").on("click", (e) => {
        e.preventDefault();
        this.triggerInvisibleFormSubmit();
      });

      // Shop Payボタンの連携
      $("[data-nobita-shop-pay]").on("click", (e) => {
        e.preventDefault();
        this.triggerShopPaySubmit();
      });

      // 別のお支払い方法ボタンの連携
      $("[data-nobita-alternative-payment]").on("click", (e) => {
        e.preventDefault();
        this.triggerAlternativePayment();
      });
    }

    syncInitialState() {
      // 初期状態の同期
      const $activeVariant = $("[data-nobita-variant-selector] li.active");
      if ($activeVariant.length) {
        this.currentVariantId = $activeVariant.data("variant-id");
        this.updateInvisibleFormVariant(this.currentVariantId);
      }

      this.updateInvisibleFormQuantity();
    }

    updateQuantityDisplay() {
      $("[data-nobita-quantity-display]").text(this.currentQuantity);
    }

    updateInvisibleFormVariant(variantId, variantTitle) {
      const $invisibleForm = $(".nobita-product-form");
      if ($invisibleForm.length) {
        // バリアント選択の更新
        const $variantInput = $invisibleForm.find('input[name="id"]');
        if ($variantInput.length) {
          $variantInput.val(variantId);
        }

        // バリアント選択UIの更新（もしあれば）
        const $variantPicker = $invisibleForm.find(
          'input[type="radio"][value="' + variantTitle + '"]',
        );
        if ($variantPicker.length) {
          $variantPicker.prop("checked", true).trigger("change");
        }
      }
    }

    updateInvisibleFormQuantity() {
      const $invisibleForm = $(".nobita-product-form");
      if ($invisibleForm.length) {
        const $quantityInput = $invisibleForm.find('input[name="quantity"]');
        if ($quantityInput.length) {
          $quantityInput.val(this.currentQuantity);
        }
      }
    }

    triggerInvisibleFormSubmit() {
      const $invisibleForm = $(".nobita-product-form");
      if ($invisibleForm.length) {
        const $submitButton = $invisibleForm.find('button[type="submit"]');
        if ($submitButton.length && !$submitButton.prop("disabled")) {
          $submitButton.click();
        } else {
          console.warn("NOBITA: カートに追加ボタンが見つからないか、無効になっています。");
        }
      } else {
        console.warn("NOBITA: 非表示フォームが見つかりません。");
      }
    }

    triggerShopPaySubmit() {
      const $invisibleForm = $(".nobita-product-form");
      if ($invisibleForm.length) {
        // Shop Payボタンを探して実行
        // TODO: あとで修正
        // const $shopPayWalletButton = $invisibleForm.find("shop-pay-wallet-button");
        const $shopPayWalletButton = $invisibleForm.find(
          "more-payment-options-link a, .shopify-payment-button__more-options",
        );
        if ($shopPayWalletButton.length) {
          $shopPayWalletButton[0].click();
        } else {
          // Shop Payが利用できない場合は通常のカートに追加を実行
          console.warn("NOBITA: Shop Payボタンが見つかりません。通常のカートに追加を実行します。");
          this.triggerInvisibleFormSubmit();
        }
      } else {
        console.warn("NOBITA: 非表示フォームが見つかりません。");
      }
    }

    triggerAlternativePayment() {
      const $invisibleForm = $(".nobita-product-form");
      if ($invisibleForm.length) {
        // 非表示フォーム内の「別のお支払い方法」リンクを探す
        const $alternativePaymentLink = $invisibleForm.find(
          "more-payment-options-link a, .shopify-payment-button__more-options",
        );

        if ($alternativePaymentLink.length) {
          // 見つかった場合はそのリンクをクリック
          $alternativePaymentLink[0].click();
        } else {
          // 見つからない場合は、まずカートに追加してからカートページに遷移
          this.triggerInvisibleFormSubmit();
        }
      } else {
        console.warn("NOBITA: 非表示フォームが見つかりません。");
      }
    }
  }

  // NOBITA商品フォーム連携の初期化
  if ($("[data-nobita-add-to-cart]").length && $(".nobita-product-form").length) {
    new NobitaProductFormConnector();
  }
});
